
import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="text-4xl font-bold text-[#1A3A52] mb-8 font-['Playfair_Display']">
              Who We Are
            </h3>
            <div className="prose prose-lg text-gray-700 leading-relaxed">
              <p className="mb-6">
                <strong>Conte Accounting Advisory</strong> was founded in 2007 by accountant
                <strong> Marcos Henrique Conte, CRC/PR 047.892</strong>. With a degree in Accounting Sciences
                from UFPR and specialization in Comptrollership and Finance from FAE Business School, our team
                combines technical knowledge with humanized service.
              </p>
              <p className="mb-6">
                We serve from MEI to medium-sized companies with solutions in <strong>accounting</strong>,
                <strong> personnel department</strong>, and <strong>tax planning</strong>, so
                you can focus on entrepreneurship.
              </p>
              <p>
                Our mission is to be the strategic partner your company needs to grow in a
                sustainable and organized way, always with transparency and excellence in service.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="text-center p-6 bg-[#F8F9FA] rounded-lg">
                <div className="text-3xl font-bold text-[#00A896] mb-2">18+</div>
                <div className="text-sm text-gray-600">Years of Experience</div>
              </div>
              <div className="text-center p-6 bg-[#F8F9FA] rounded-lg">
                <div className="text-3xl font-bold text-[#00A896] mb-2">500+</div>
                <div className="text-sm text-gray-600">Companies Served</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img
              src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/700995b113e9ae579d49d85178115583.png"
              alt="Marcos Henrique Conte - Accountant CRC/PR 047.892"
              className="w-full h-auto rounded-2xl shadow-2xl object-cover object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-[#1A3A52] text-white p-6 rounded-lg shadow-xl">
              <div className="text-sm font-medium">Marcos Henrique Conte</div>
              <div className="text-xs text-[#C9A961]">CRC/PR 047.892</div>
              <div className="text-xs mt-1">Responsible Accountant</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
